export enum ErrorName {
  invalid_token = 'invalid_token',
  invalid_scope = 'invalid_scope',
  invalid_grant = 'invalid_grant',
  not_found = 'not_found',
  conflict = 'conflict',
  unknown = 'unknown',
};
